const helpButton = document.querySelector('.help-button');
const help = document.querySelector('.help');

if (helpButton && help) {
  const body = document.querySelector('body');
  const bodyClassOpen = 'body--help-open';

  // Open help-overlay
  const openHelp = (event) => {
    body.classList.add(bodyClassOpen);
    helpButton.setAttribute('aria-expanded', body.classList.contains(bodyClassOpen));
    help.setAttribute('aria-expanded', body.classList.contains(bodyClassOpen));
    event.stopPropagation();
    return false;
  };
  helpButton.addEventListener('click', openHelp);

  // Close help-overlay
  const closeMenu = () => {
    body.classList.remove(bodyClassOpen);
    helpButton.removeAttribute('aria-expanded', body.classList.contains(bodyClassOpen));
    help.removeAttribute('aria-expanded', body.classList.contains(bodyClassOpen));
  };
  help.querySelector('.help__close').addEventListener('click', closeMenu);

  // Click outside
  const clickOutsideHelp = (event) => {
    const isClickInside = help.contains(event.target);
    if (!isClickInside) {
      body.classList.remove(bodyClassOpen);
      helpButton.removeAttribute('aria-expanded', body.classList.contains(bodyClassOpen));
      help.removeAttribute('aria-expanded', body.classList.contains(bodyClassOpen));
    }
  };
  document.addEventListener('click', clickOutsideHelp);
}
